<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        :ref="ieVerifyGrid"
        config-module="2102"
        :is-collapse-list="true"
        :grid-options="gridOptions"
        :is-append-query="true"
        :reset="true"
        :lob="'IE'"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :record-expand-status="true"
        :input-enter-query="true"
        grid-config-module="170004"
        @click-more="value=>{isAdvancedQuery=value}"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
      >
        <template slot="operations">
          <el-button
            :disabled="!selectedRow || hqDisabledViewDetail || (!isHQ && !validSingleSelect) || hierarchyDisabledViewDetail"
            no="look"
            type="success"
            @click="toLook()"
          >{{ $t('common.btn.look') }}</el-button>
          <el-button
            :disabled="JobUtils.isBlockJob(currentRow) || !validSingleSelect || !hierarchyValidSingleSelect"
            no="edit"
            type="success"
            @click="toEdit"
          >{{ $t('common.btn.edit') }}</el-button>
          <el-button
            v-permission="[addButtonPermission]"
            no="new"
            :disabled="hqDisabledOperate"
            type="primary"
            @click="toAdd"
          >{{ $t('common.btn.new') }}</el-button>
          <el-button
            v-permission="[addButtonPermission]"
            no="Clone"
            :disabled="!selectedRow || !validSingleSelect || !hierarchyValidSingleSelect"
            type="primary"
            @click="toCopy"
          >{{ $t('SeaExport.Clone') }}</el-button>
          <!--审核通过-->
          <el-button v-show="role.acceptRole" no="PassAudit" type="primary" @click="acceptHandler(0)">{{ $t('SeaExport.PassAudit') }}</el-button>
          <!--拒绝-->
          <el-button v-show="role.rejectRole" no="Refuse" type="primary" @click="rejectHandler(0)">{{ $t('SeaExport.Refuse') }}</el-button>
          <!--复核通过-->
          <el-button v-show="role.reviewThroughRole && pretrialReviewConfig" no="ReviewThrough" type="primary" @click="btVerifyReviewThroughHandler(0)">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
          <!--复核拒绝-->
          <el-button v-show="role.reviewRefusalRole && pretrialReviewConfig" no="ReviewRefusal" :disabled="reviewRefusalBtn" type="primary" @click="btVerifyReviewRefusalHandler(0)">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid-wrapper
          config-module="170004"
          :grid-options="gridOptions"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-selected-color="false"
          :wrap-text="true"
          style="width: 100%;"
          :show-row-groups="dataListDragGroup"
          :pre-column-state-callback="p => preColumnStateCallback(p)"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          @gridReady="params=>{gridApi=params.api}"
          @columnRowGroupChanged="() => { this.$refs[ieVerifyGrid].clickCollapseList() }"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          config-module="170004"
          :total="total"
          :page-count="pageCount"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="toQuery()"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!--审核通过-->
    <accept-dialog
      v-if="acceptDialog.visible"
      :visible.sync="acceptDialog.visible"
      :job-model="acceptDialog.job || {}"
      :submit-call-back="acceptDialog.submitCallBack"
      :job-list="acceptDialog.jobs"
    />
    <!--拒绝-->
    <reject-dialog
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :job-list="rejectWindow.jobList"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      lob="IE"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 信控验证弹框 -->
    <confirm-dialog-window
      v-if="confirmDialogWindow.visible"
      :visible.sync="confirmDialogWindow.visible"
      :message-title="confirmDialogWindow.messageTitle"
      :content="confirmDialogWindow.content"
      :show-confirm-btn="confirmDialogWindow.showConfirmBtn"
      :confirm-call-back="confirmDialogWindow.confirmCallBack"
    />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :editable="cooperationVerifyDialog.editable"
    />
  </div>
</template>

<script>
import bookingTreeGridJS from '@/views/cargo/v0/Integrated/components/booking/bookingTreeGrid.js'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage, stringToBool } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import URL from '@/api/urlTranslator'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import StateDialog from '@/components/Cargo/Job/StateDialog'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import BookingTreeGridMixin from '@/mixin/BookingTreeGridMixin'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/ContainerLoadType'
import DateUtils from '@/utils/dateUtils'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import OpVerifyFrameReject from '@/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameReject'
import { cache } from '@/utils/cacheManager'
import acceptDialog from '@/views/cargo/v0/Integrated/components/verify/acceptDialog'
import rejectDialog from '@/views/cargo/v0/AirExport/components/verify/rejectDialog'
import ConfirmDialogWindow from '@/views/cargo/v0/SeaExport/components/verify/ConfirmDialogWindow'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'

export default {
  name: 'IEVerifyTreeGrid',
  components: {
    cooperationVerifyDialog,
    cargoTemplateSelectorDialog,
    ConfirmDialogWindow,
    rejectDialog,
    acceptDialog,
    OpVerifyFrameReject, searchItem, CargoAdvanceSelect, BatchCheckingWindow, sopStateDialog, StateDialog, cargoAgGridWrapper },
  mixins: [BookingTreeGridMixin],
  props: {
    context: { type: Object, required: true },
    isQuery: { type: Boolean, default: false },
    integratedLogisticsType: { type: String, default: '' }
  },
  data() {
    return {
      notRefresh: false,
      appendQuery: false, // 追加查询
      TYPE_NAMES,
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      useCheckRule: false, // 是否启用验证规则
      salesCanSeeBookingAgent: false,
      isAdvancedQuery: false, // 是否为高级查询
      useOrderCenterModes: false,
      customSearchItems: [],
      simpleFilter: {
        conditions: [],
        branchId: 0
      },
      complexFilter: {
        conditions: [],
        branchId: 0
      },
      pageNum: 1,
      pageSize: 50,
      total: 0,
      pageCount: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => !!params.data,
            innerRenderer: params => {
              return `<span>${params.value}</span>`
            }
          }
        },
        onRowDataChanged: event => {
          // 重置（多选）选中行
          this.selectedRows = []
          this.$refs[this.ieVerifyGrid].clickCollapseList()
        },
        // 单选（勾选框或者其他列，都会触发）
        onCellFocused: (event) => {
          if (!event) return
          this.selectedRowIndex = event.rowIndex
        },
        // 多选（勾选框触发）
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          const data = event.data
          if (this.hierarchyViewList && !this.hierarchyViewDetail) {
            if (!this.matchOwnerBranch(data)) {
              return
            }
          }
          if (this.hqViewAllList) {
            const curOfficeId = this.$store.getters.currentOfficeId
            const data = event.data
            if (curOfficeId === 1) {
              if (!this.hqViewAllDetail) {
                return
              }
            } else {
              if (data.opOffice !== curOfficeId && data.salesOffice !== curOfficeId && !this.mactchCooperateBranch(data.cooperatebranch, this.$store.getters.currentOffice)) {
                return
              }
            }
          }
          if (event.colDef.field === 'sopState') {
            LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', true)
            this.sopStateDialog.visible = true
            this.currentRow = data
            return
          }
          this.toLook(event.data)
        },
        getRowStyle: (params) => {
          if (!params.data) {
            return
          }
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
            Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
            JobUtils.isBlockJob(row)) {
            return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
          } else {
            const jobState = String(row.jobState) || ''
            for (const stateColor of colorSettings) {
              if (jobState === stateColor.colorKey) {
                return { 'background': stateColor.colorValue }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Status'),
          colId: 'jobState',
          field: 'jobState',
          cellRenderer: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filter: false,
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerContactPerson'),
          field: 'customerContact',
          colId: 'customerContact',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SettlementType'),
          field: 'creditDateLimited',
          colId: 'creditDateLimited',
          hide: true,
          valueFormatter: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.value !== '') {
              return (Number(params.value) > 0 || Number(params.data.creditDateType) > 0) ? this.$t('Message.Monthly') : this.$t('Message.ByTicket')
            }
            return ''
          },
          filter: true,
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.data.creditDateLimited !== '') {
              return (Number(params.data.creditDateLimited) > 0 || Number(params.data.creditDateType) > 0) ? this.$t('Message.Monthly') : this.$t('Message.ByTicket')
            }
            return ''
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvoicingMethod'),
          field: 'creditDateType',
          colId: 'creditDateType',
          hide: true,
          valueFormatter: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.value !== '') {
              return Number(params.value) > 0 ? this.$t('CargoMsg.Cargo_LotteryDraw') : this.$t('CargoMsg.Cargo_SchoolMonth')
            }
            return ''
          },
          filter: true,
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.data.creditDateType !== '') {
              return Number(params.data.creditDateType) > 0 ? this.$t('CargoMsg.Cargo_LotteryDraw') : this.$t('CargoMsg.Cargo_SchoolMonth')
            }
            return ''
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'opOffice',
          colId: 'opOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateOpCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: 'salesOffice',
          colId: 'salesOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateSalesOffice), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: 'salesDept',
          colId: 'salesDept',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateSalesDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.BusinessCreator'),
          colId: 'createdBy',
          field: 'createdBy',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 75,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          cellRenderer: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.data.customerId > 0) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
            }
            return ''
          },
          filter: false,
          filterParams: {},
          width: 150
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: 'cargoSalesId',
          hide: true,
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCargoSalesId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ConsignationStatusTime'),
          colId: 'crossTenantHistoryStateDate',
          field: 'crossTenantHistoryStateDate',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ConsignationStatus'),
          colId: 'crossTenantHistoryState',
          field: 'crossTenantHistoryState',
          cellRenderer: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.crossTenantHisStateCommonFun(params.data, params.value)
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          colId: 'customerRefNo',
          field: 'customerRefNo',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          colId: 'poNo',
          field: 'poNo',
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          colId: 'op',
          field: 'op',
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOpId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Sales'),
          colId: 'sales',
          field: 'sales',
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateSales), 'auto_sales')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp',
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOverseaOp), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.Accrued'),
          colId: 'provisioned',
          field: 'provisioned',
          hide: true,
          cellRenderer: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CustomerService'),
          colId: 'csr',
          field: 'csr',
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCsrId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.Documents'),
          colId: 'dc',
          field: 'dc',
          hide: true,
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateDcId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          colId: 'customsDate',
          field: 'customsDate',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          colId: 'customJobType',
          field: 'customJobType',
          hide: true,
          valueGetter: params => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name', SystemConstants.IE.code, false)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.OperationTips'),
          colId: 'operationTips',
          field: 'operationTips',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          colId: 'remarks',
          field: 'remarks',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          colId: 'userDefinedField1',
          field: 'userDefinedField1',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          colId: 'userDefinedField2',
          field: 'userDefinedField2',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          colId: 'userDefinedField3',
          field: 'userDefinedField3',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          colId: 'userDefinedField4',
          field: 'userDefinedField4',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'projectName',
          colId: 'projectName',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectBatch'),
          field: 'projectBatch',
          colId: 'projectBatch',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
          field: 'receivableChargeLockedStatus',
          colId: 'receivableChargeLockedStatus',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
          field: 'payableChargeLockedStatus',
          colId: 'payableChargeLockedStatus',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.ChannelNo'),
          field: 'channelNo',
          colId: 'channelNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
          field: 'receivableChargeInput',
          colId: 'receivableChargeInput',
          width: 150,
          filter: false,
          filterParams: {},
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.chargeInputLabelFunction(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: 'opDepartment',
          colId: 'opDepartment',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateOpDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          field: 'plannerDepartment',
          colId: 'plannerDepartment',
          hide: true,
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.AirlinePerson'),
          field: 'planner',
          colId: 'planner',
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperatePlanner), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId1), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId2), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.PreCommitUser'),
          field: 'preCommitUser',
          colId: 'preCommitUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PreCommitDate'),
          field: 'preCommitDate',
          colId: 'preCommitDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CommitUser'),
          field: 'commitUser',
          colId: 'commitUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'shutOut',
          colId: 'shutOut',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ShutOutDate'),
          field: 'shutOutDate',
          colId: 'shutOutDate',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.SubmissionDate'),
          field: 'submissionDate',
          colId: 'submissionDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          colId: 'riskReason',
          field: 'riskReason',
          width: 150
        }, {
          headerName: this.$t('SeaExport.LockJobUser'),
          field: 'lockJobUser',
          colId: 'lockJobUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReturnModule'),
          field: 'returnType',
          colId: 'returnType',
          hide: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            const type = Number(params.data && params.data.returnType)
            if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
            if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
            return ''
          },
          valueGetter: (params) => {
            const type = Number(params.data && params.data.returnType)
            if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
            if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReturnReason'),
          field: 'returnRemark',
          colId: 'returnRemark',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobDate'),
          field: 'lockJobDate',
          colId: 'lockJobDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: 'cargoCode',
          colId: 'cargoCode',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_11') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: 'warehouseCmp',
          colId: 'warehouseCmp',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_10') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          field: 'quantityContract',
          colId: 'quantityContract',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.numberColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          field: 'weightContract',
          colId: 'weightContract',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          field: 'cubageContract',
          colId: 'cubageContract',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          colId: 'quantityActual',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.numberColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          colId: 'weightActual',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          colId: 'cubageActual',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.LocalService'),
          field: 'loadingTerm',
          colId: 'loadingTerm',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.loadingTermNewLabelFunction(params.data, params.value)
          },
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.loadingTermNewLabelFunction(params.data, params.data.loadingTerm)
          },
          filterParams: {},
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DangerousGoodsClassification'),
          field: 'danClassNo',
          colId: 'danClassNo',
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.DangerousGoodsUNNo'),
          field: 'danUNNo',
          colId: 'danUNNo',
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.CustomsBroker'),
          field: 'customsBroker',
          colId: 'customsBroker',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_9') : ''
          },
          hide: true,
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          colId: 'cargoEnglishName',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.HsCode'),
          field: 'hsCode',
          colId: 'hsCode',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
          field: 'costChargeInput',
          colId: 'costChargeInput',
          width: 150,
          filter: false,
          filterParams: {},
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.chargeInputLabelFunction(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.FreeDemurrage'),
          field: 'freeDemurrage',
          colId: 'freeDemurrage',
          width: 150,
          filterParams: {},
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.FreeDetention'),
          field: 'freeDetention',
          colId: 'freeDetention',
          width: 150,
          filterParams: {},
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_SpecialPriceInstructions'),
          field: 'salePriceRemarks',
          colId: 'salePriceRemarks',
          hide: true,
          width: 150
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'businessDate', colId: 'businessDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Door'), field: 'doorNameStar', colId: 'doorNameStar', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.DoorAddress'), field: 'doorAddrStar', colId: 'doorAddrStar', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.DoorCity'), field: 'cityCodeStar', colId: 'cityCodeStar', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.WareHouseName'), field: 'truckWarehouseName', colId: 'truckWarehouseName', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.Driver'), field: 'driverName', colId: 'driverName', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.ComprehensiveLogisticsOrderType'), field: 'containerLoadType', colId: 'containerLoadType', width: 200,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          }
        },
        { headerName: this.$t('SeaExport.ComprehensiveLogisticsTransportationType'), field: 'transportType', colId: 'transportType', width: 200, enableRowGroup: true },
        {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 100,
          enableRowGroup: true
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          hide: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ServiceCode'),
          field: 'vesselLineCode',
          colId: 'vesselLineCode',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.AirlineArea'),
          field: 'regionName',
          colId: 'regionName',
          hide: true,
          cellRenderer: (params) => {
            if (params.value && !this.isZh) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'name', params.value, 'nameEnglish')
            }
            return params.value
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture2'),
          field: 'etd',
          colId: 'etd',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
          },
          width: 200,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CarrierAgent'),
          field: 'carrierAgentId',
          colId: 'carrierAgentId',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DateOfArrival2'),
          field: 'eta',
          colId: 'eta',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo',
          hide: true,
          width: 150,
          tooltipValueGetter: (params) => params.value,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.HarborDistrict'),
          field: 'portDistrict',
          colId: 'portDistrict',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CYOpeningTime'),
          field: 'terminalOpendate',
          colId: 'terminalOpendate',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.PortAreaCYCutOffTime'),
          field: 'terminalCutoff',
          colId: 'terminalCutoff',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PortCodeOfDischarge'),
          field: 'portCode',
          colId: 'portCode',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
          field: 'atd',
          colId: 'atd',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualDateOfArrival2'),
          field: 'ata',
          colId: 'ata',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          colId: 'exChangeAgent',
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ArrivalTime'),
          field: 'actualArrivalTime',
          colId: 'actualArrivalTime',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          colId: 'chargeWeight',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          colId: 'warehouseNo',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.DestinationGatePoint'),
          field: 'doorNameEnd',
          colId: 'doorNameEnd',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.AddressOfDestinationGatePoint'),
          field: 'doorAddressEnd',
          colId: 'doorAddressEnd',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.DestinationGateCity'),
          field: 'cityCodeEnd',
          colId: 'cityCodeEnd',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.EstimatedPackingDate'),
          field: 'loadingDate',
          colId: 'loadingDate',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ActualPackingDate'),
          field: 'actLoadingDate',
          colId: 'actLoadingDate',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ExpectedArrivalDate2'),
          field: 'arriveDate',
          colId: 'arriveDate',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ActualArrivalDate'),
          field: 'actualArrivalDate',
          colId: 'actualArrivalDate',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
          field: 'dispatchingPlace',
          colId: 'dispatchingPlace',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'carrierId', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
          field: 'actTakeTime',
          colId: 'actTakeTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          hide: !this.useOrderCenterMode,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          hide: !this.useOrderCenterMode,
          enableRowGroup: true
        }, { headerName: this.$t('CargoMsg.Cargo_JobProfitShare'), colId: 'jobProfitShare', field: 'jobProfitShare', width: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true
        }, {
          headerName: this.$t('SeaExport.SOPStatus'),
          field: 'sopState',
          colId: 'sopState',
          width: 100,
          tooltipValueGetter: (params) => params.value,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
          field: 'trackingTemplateUuid',
          width: 180,
          colId: 'trackingTemplateUuid',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.value, 'templateName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessExpirationDate'), field: 'specialApprovalDate', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          width: 180,
          hide: true,
          colId: 'incoTerm',
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateCsrCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateDcCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableDomestic'),
          colId: 'verifyStateReceivableDomestic',
          field: 'verifyStateReceivableDomestic',
          width: 140,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableOversea'),
          colId: 'verifyStateReceivableOversea',
          field: 'verifyStateReceivableOversea',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Auditor'),
          colId: 'fcAuditUser',
          field: 'fcAuditUser',
          width: 140,
          hide: true,
          valueGetter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.fcAuditUser, 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuditDate'),
          colId: 'fcAuditDate',
          field: 'fcAuditDate',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.BusinessLockedStatus'), field: 'businessLock', width: 100, colId: 'businessLock',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLockedStatusLabelFunc(stringToBool(params.value))
          },
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_transferPortCode'),
          colId: 'transferPortCode',
          field: 'transferPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
          colId: 'payableInvoiceState',
          field: 'payableInvoiceState',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.receivableInvoiceStateLabelFunction(params.data.payableInvoiceState),
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivableFeeLockTime2'),
          colId: 'receivableChargeLockedDate',
          field: 'receivableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime2'),
          colId: 'payableChargeLockedDate',
          field: 'payableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
          colId: 'payableChargeLockedPerson',
          field: 'payableChargeLockedPerson',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.getPayableChargeLockedPerson(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InterestAmountCurrency'),
          colId: 'interestAmountCurrency',
          field: 'interestAmountCurrency',
          width: 140,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PreAuditPerson'),
          field: 'preVerifier',
          colId: 'preVerifier',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PreverifyStatus'),
          field: 'preverifyState',
          colId: 'preverifyState',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.getPreverifyStateCN(Number(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PreAuditTime'),
          field: 'preVerifyDate',
          colId: 'preVerifyDate',
          enableRowGroup: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          field: 'trustFromJob',
          colId: 'trustFromJob',
          enableRowGroup: true,
          width: 200
        },
        {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          field: 'relatedJob',
          colId: 'relatedJob',
          enableRowGroup: true,
          width: 200
        }
      ],
      rowData: [],
      gridApi: null,
      selectedRowIndex: -1,
      selectedRows: [],
      documentManage: new DocumentManage(),
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      chargeCommand: this.$t('SeaExport.AddCharges'),
      stateDialog: {
        visible: false,
        rows: [],
        trackingList: []
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      role: {
        acceptRole: this.$checkPermission(['button_ieVerify_accept']), // 审核权限
        rejectRole: this.$checkPermission(['button_ieVerify_reject']), // 拒绝权限
        reviewThroughRole: this.$checkPermission(['button_ieVerify_reviewThrough']), // 审核权限
        reviewRefusalRole: this.$checkPermission(['button_fmVerify_reviewRefusal']) // 复核拒绝
      },
      JobUtils,
      currentRow: {},
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false
      },
      isZY: false,
      defaultSearchItems: [],
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      perConfigName: '',
      gridRefreshId: 0,
      pretrialReviewConfig: false,
      creditRestrictionForBooking: false,
      acceptDialog: { // 审核通过弹窗
        visible: false,
        job: null,
        jobs: [], // 当前选中业务
        submitCallBack: null
      },
      rejectWindow: { // 拒绝弹窗
        visible: false,
        jobNo: '',
        jobList: [],
        rejectCallBack: null
      },
      batchJobList: [], // 批量审核通过的业务列表
      confirmDialogWindow: { // 信控验证使用
        visible: false,
        messageTitle: '',
        content: '',
        confirmCallBack: null,
        showConfirmBtn: ''
      },
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        jobUuids: [],
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true
      },
      unNeedSelected: true
    }
  },
  computed: {
    ieVerifyGrid() {
      return 'ieVerifyGrid'
    },
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    selectedRow() {
      if (this.gridApi) {
        let uuid
        this.gridApi.forEachNode(node => {
          if (node.data && this.selectedRowIndex === node.rowIndex) {
            uuid = node.data.uuid
          }
        })
        if (uuid) {
          let key
          this.rowData.map((item, index) => {
            if (item.uuid === uuid) {
              key = index
            }
          })
          return this.rowData[key]
        }
        return this.rowData[this.selectedRowIndex]
      } else {
        return this.rowData[this.selectedRowIndex]
      }
    },
    btnCooperateEnable() {
      return this.selectedRow ? (this.isCooperate(this.selectedRow.cooperateStatus) && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(this.selectedRow.cooperateStatus)) : false
    },
    enableBtnSplit() {
      return this.selectedRows.findIndex(p => p.lclMasterUuid) >= 0
    },
    batchSelectFlag() {
      return this.selectedRows.length > 0
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    actionOrderUrl() {
      return URL.sys.importOrderTemplate
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.context.config ? Number(this.context.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return this.context.config ? Number(this.context.config.get('orderCenterBranch')) === 1 : false
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    isHQ() {
      return this.$store.getters.currentOfficeId === 1
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledViewDetail() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList && !this.hqViewAllDetail
    },
    validSingleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (this.selectedRow && this.selectedRow.opOffice !== this.$store.getters.currentOfficeId && this.selectedRow.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.selectedRow.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      return true
    },
    validMultipleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        for (const row of this.selectedRows) {
          if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
            return false
          }
        }
      }
      return true
    },
    addButtonPermission() {
      if (!this.integratedLogisticsType) {
        return 'button_IEBooking_addIEBooking'
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
        return 'button_TTIEBooking_addIEBooking'
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
        return 'button_CLIEBooking_addIEBooking'
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
        return 'button_ICIEBooking_addIEBooking'
      } else {
        return 'button_IEBooking_addIEBooking'
      }
    },
    finalColumnDefs() {
      if (this.$store.state.uiCustom.enable && this.integratedLogisticsType) {
        if (this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
          return UICustomUtil.handleColumnDefs(UICustomConstants.IC_BOOKING_MODULE, this.$store.getters.currentOfficeId, this.columnDefs)
        }
        // else if (this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
        //   return UICustomUtil.handleColumnDefs(UICustomConstants.TT_BOOKING_MODULE, this.$store.getters.currentOfficeId, this.columnDefs)
        // } else if (this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
        //   return UICustomUtil.handleColumnDefs(UICustomConstants.CL_BOOKING_MODULE, this.$store.getters.currentOfficeId, this.columnDefs)
        // }
      }
      return this.columnDefs
    },
    rejectBtn() {
      if (!this.selectedRow) {
        return false
      }
      return !((this.selectedRow && this.selectedRow.jobState === -1 && ![2, 3, 5].includes(this.selectedRow.preverifyState)) || this.btnCooperateEnable)
    },
    reviewRefusalBtn() {
      if (!this.selectedRow) {
        return false
      }
      return !(this.selectedRow && this.selectedRow.jobState === -1 && this.selectedRow.preverifyState === 2)
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        if (this.hqViewAllList || this.hierarchyViewList) {
          this.customSearchItems = await this.getCustomSearchItems()
        }
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.useOrderCenterModes = Number(this.context.config.get('useOrderCenterMode')) === 1
    this.allowPartialCheckPass = Number(this.context.config.get('allowPartialCheckPass')) === 1
    this.useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
    this.salesCanSeeBookingAgent = Number(this.context.config.get('SalesCanSeeBookingAgent')) === 1
    this.isZY = String(this.context.config.get('ToExoSystem')) === 'zy'
    this.dataListDragGroup = Number(this.context.config.get('DataListDragGroup')) === 1
    this.pretrialReviewConfig = parseInt(this.context.config.get('PretrialReviewIE')) === 1
    this.creditRestrictionForBooking = parseInt(this.context.config.get('CreditRestrictionForBooking'))
    await this.initColumnDefs()
    this.init()
    if (this.isQuery) return
    this.queryLastModifyBookingByDay()
    if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
      this.columnDefs.push(
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'truckingPlateNumber',
          colId: 'truckingPlateNumber',
          width: 200,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNos',
          colId: 'sealNos',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CarryingCaseYard'),
          field: 'truckingPlaceOfDeps',
          colId: 'truckingPlaceOfDeps',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ReturnYard'),
          field: 'truckingPlaceOfDests',
          colId: 'truckingPlaceOfDests',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleNumberOne'),
          colId: 'destinationVehicleNumberOne',
          field: 'destinationVehicleNumberOne',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleRegister'),
          colId: 'destinationVehicleRegister',
          field: 'destinationVehicleRegister',
          width: 140,
          hide: true,
          enableRowGroup: true
        }
      )
    } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
      this.columnDefs.push(
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'truckingPlateNumber',
          colId: 'truckingPlateNumber',
          width: 200, enableRowGroup: true
        }
      )
    } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
      this.columnDefs.push(
        {
          headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
          field: 'khPlateNumber',
          colId: 'khPlateNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
          field: 'khTrailerNumber',
          colId: 'khTrailerNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_bargePlateNumber'),
          field: 'bargePlateNumber',
          colId: 'bargePlateNumber',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_secondPlateNumber'),
          field: 'secondPlateNumber',
          colId: 'secondPlateNumber',
          hide: true,
          width: 100,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_secondTrailerNumber'),
          field: 'secondTrailerNumber',
          colId: 'secondTrailerNumber',
          hide: true,
          width: 100,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khDeclareActTime'),
          colId: 'declareTime',
          field: 'declareTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khEntryActTime'),
          colId: 'actEntryTime',
          field: 'actEntryTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khExitActTime'),
          colId: 'actExitTime',
          field: 'actExitTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_transferDeclareCompletedActTime'),
          colId: 'declareCompletedTime',
          field: 'declareCompletedTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleNumberOne'),
          colId: 'destinationVehicleNumberOne',
          field: 'destinationVehicleNumberOne',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleRegister'),
          colId: 'destinationVehicleRegister',
          field: 'destinationVehicleRegister',
          width: 140,
          hide: true,
          enableRowGroup: true
        }
      )
    } else {
      this.columnDefs.push(
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'truckingPlateNumber',
          colId: 'truckingPlateNumber',
          width: 200,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
          field: 'khPlateNumber',
          colId: 'khPlateNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
          field: 'khTrailerNumber',
          colId: 'khTrailerNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNos',
          colId: 'sealNos',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CarryingCaseYard'),
          field: 'truckingPlaceOfDeps',
          colId: 'truckingPlaceOfDeps',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ReturnYard'),
          field: 'truckingPlaceOfDests',
          colId: 'truckingPlaceOfDests',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_bargePlateNumber'),
          field: 'bargePlateNumber',
          colId: 'bargePlateNumber',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_secondPlateNumber'),
          field: 'secondPlateNumber',
          colId: 'secondPlateNumber',
          hide: true,
          width: 100,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_secondTrailerNumber'),
          field: 'secondTrailerNumber',
          colId: 'secondTrailerNumber',
          hide: true,
          width: 100,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khDeclareActTime'),
          colId: 'declareTime',
          field: 'declareTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khEntryActTime'),
          colId: 'actEntryTime',
          field: 'actEntryTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khExitActTime'),
          colId: 'actExitTime',
          field: 'actExitTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_transferDeclareCompletedActTime'),
          colId: 'declareCompletedTime',
          field: 'declareCompletedTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleNumberOne'),
          colId: 'destinationVehicleNumberOne',
          field: 'destinationVehicleNumberOne',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleRegister'),
          colId: 'destinationVehicleRegister',
          field: 'destinationVehicleRegister',
          width: 140,
          hide: true,
          enableRowGroup: true
        }
      )
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showBusinessInfo', function() {
      self.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: bookingTreeGridJS.methods
}
</script>

<style scoped lang="scss">
</style>
